import { useState } from "react";
import useIsSocietyCountry from "@icarius-app/components/wrapper/hooks/useIsSocietyCountry";
import * as yup from "yup";

const useHandleForm = (data, createCallback, modifyCallback, invalidDataCallback) => {
    const isChile = useIsSocietyCountry("CL");
    const isPeru = useIsSocietyCountry("PE");

    const isCreate = !Boolean(data);

    const createInitialData = () => {
        const getInitialFieldData = (fieldName) => {
            return isCreate ? "" : data[fieldName];
        };

        const fieldNames = ["code", "name", "institutionCode", "previredCode", "lreCode"];

        return fieldNames.reduce((initialData, fieldName) => {
            return {
                ...initialData,
                [fieldName]: getInitialFieldData(fieldName),
            };
        }, {});
    };

    const [formData, setFormData] = useState(createInitialData());

    const dataIsValid = async () => {
        const codeRegex = isPeru ? /^[A-Z0-9]+/ : /^[A-Z]+[A-Z0-9]*/;
        const institutionCodeRegex = /^[a-zA-Z0-9-]*/;

        let schema = yup.object().shape({
            code: yup
                .string()
                .matches(codeRegex)
                .required(),
            name: yup.string().required(),
            institutionCode: yup.string().matches(institutionCodeRegex),
            previredCode: yup.string().when([], {
                is: () => isChile,
                then: yup.string().required(),
            }),
            lreCode: yup.string(),
        });

        return await schema
            .validate(formData, { abortEarly: false })
            .then((castData) => castData)
            .catch((err) => {
                if (err instanceof yup.ValidationError) {
                    err.inner.forEach((error) => {
                        console.log(error.message);
                    });
                    return false;
                }
            });
    };

    const submit = async () => {
        if (await dataIsValid()) {
            let dataToSend = { ...formData };

            if (!isCreate) {
                dataToSend = { ...dataToSend, internalCode: data.internalCode };
            }

            isCreate ? createCallback(dataToSend) : modifyCallback(dataToSend);
            return true;
        } else {
            invalidDataCallback();
            return false;
        }
    };

    const formatValue = (value, fieldName) => {
        if (fieldName === "code") {
            return value.length > 0 ? value.replace(/\s/g, "").toUpperCase() : "";
        }

        return value;
    };

    const setFormValue = (value, fieldName) => {
        setFormData({
            ...formData,
            [fieldName]: formatValue(value, fieldName),
        });
    };

    return { isCreate, formData, setFormValue, submit };
};

export default useHandleForm;
